import React from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'
import colours from '../lib/colours'
import styled from 'styled-components'
import IEventedComponent from '../components/IEventedComponent'
import { MobileDeviceWidth } from '../lib/constants'

const StyledWrapper = styled.div`
  color: ${colours.darkPurple};
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const StyledContainer = styled.div`
  flex: 1;
  overflow: hidden;
  @media (max-width: ${MobileDeviceWidth}px) {
    height: 100%;
    display: flex;
    flex: unset;
    flex-wrap: unset;
    flex-direction: column;
  }
`

interface IProps {}

interface IState {}

class MapPageLayout extends IEventedComponent<IProps, IState> {
  render() {
    return (
      <StyledWrapper>
        <Layout>
          <SEO title="Map" description="MSA Levy Estimator" />
        </Layout>

        <StyledContainer className="row no-gutters">{this.props.children}</StyledContainer>
      </StyledWrapper>
    )
  }
}

export default MapPageLayout
